import React from "react";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import GitHubIcon from "@material-ui/icons/GitHub";
import EmailIcon from "@material-ui/icons/Email";
import {
  COLOR_BASE,
  COLOR_HIGH,
  FONT_MED,
  COLOR_FONT,
  SPACING_XSMALL,
} from "../constants";

const useStyles = makeStyles((theme) => ({
  menu: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    backgroundColor: COLOR_BASE,
  },
  link: {
    margin: SPACING_XSMALL,
    color: COLOR_FONT,
    fontWeight: "bold",
    fontSize: FONT_MED,
  },
  selectedLink: {
    margin: SPACING_XSMALL,
    color: COLOR_HIGH,
    fontWeight: "bold",
    fontSize: FONT_MED,
  },
}));

function Menu(current) {
  const classes = useStyles();

  const onClick = () => {
    current.handleDrawerToggle && current.handleDrawerToggle();
  };

  return (
    <div className={classes.menu}>
      <Link
        href={"#specialty"}
        className={
          current.current === "specialty" ? classes.selectedLink : classes.link
        }
        onClick={() => onClick()}
      >
        SPECIALTY
      </Link>
      <Link
        href={"#education"}
        className={
          current.current === "education" ? classes.selectedLink : classes.link
        }
        onClick={() => onClick()}
      >
        EDUCATION
      </Link>
      <Link
        href={"#experience"}
        className={
          current.current === "experience" ? classes.selectedLink : classes.link
        }
        onClick={() => onClick()}
      >
        EXPERIENCE
      </Link>
      <Link
        href={"#projects"}
        className={
          current.current === "projects" ? classes.selectedLink : classes.link
        }
        onClick={() => onClick()}
      >
        PROJECT
      </Link>
      <Link
        href={"#fun"}
        className={
          current.current === "fun" ? classes.selectedLink : classes.link
        }
        onClick={() => onClick()}
      >
        FUN
      </Link>
      <Link
        href={"#contact"}
        className={
          current.current === "contact" ? classes.selectedLink : classes.link
        }
        onClick={() => onClick()}
      >
        CONTACT
      </Link>
      <Link
        href={"https://www.linkedin.com/in/ryanwooyanglee"}
        className={classes.link}
        onClick={() => onClick()}
      >
        <LinkedInIcon />
      </Link>
      <Link
        href={"https://github.com/ryanwlee"}
        className={classes.link}
        onClick={() => onClick()}
      >
        <GitHubIcon />
      </Link>
      <Link
        href={"mailto:ryanwoolee@gmail.com"}
        className={classes.link}
        onClick={() => onClick()}
      >
        <EmailIcon />
      </Link>
    </div>
  );
}

export default Menu;
